import { jsx as _jsx } from "react/jsx-runtime";
import { usePaywallUpsell } from '#pplx/frontend/apps/ask/hooks/pricing-hooks/usePaywallUpsell.js';
import { useShowUpgradeButton } from '#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/useShowUpgradeButton.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import * as BUILD_CAPABILITIES from '#pplx/frontend/deployment-capabilities/build.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
const SidebarUpgradeButton = Dynamic(async () => {
    const { SidebarUpgradeButton } = await import('#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/SidebarUpgradeButton.js');
    return { default: SidebarUpgradeButton };
});
const SidebarViewPlansButton = Dynamic(async () => {
    const { SidebarViewPlansButton } = await import('#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/SidebarUpgradeButton.js');
    return { default: SidebarViewPlansButton };
});
// Single-file event: defined here at its only call site rather than in a shared package.
const sidebarProUpsellClickedEvent = {
    event: 'sidebar pro upsell clicked',
    data: {},
};
export function SidebarPlans({ isExpanded }) {
    const { status } = useSession();
    const isLoggedOut = status === 'unauthenticated';
    const showUpgradeButton = useShowUpgradeButton();
    const { track } = useInstrumentation();
    const openPaywallUpsell = usePaywallUpsell({
        allowLoggedOut: isLoggedOut,
        enterpriseOnboardingReturnTo: 'pricing',
    });
    const handleUpgradeClick = useCallback(() => {
        track(sidebarProUpsellClickedEvent);
        openPaywallUpsell({
            origin: ModalOrigin.SIDEBAR_PRO_UPSELL,
        });
    }, [track, openPaywallUpsell]);
    const handleViewPlansClick = useCallback(() => {
        openPaywallUpsell({
            origin: ModalOrigin.SIDEBAR_PRO_UPSELL,
            showFreeTier: true,
            requireLoginForFreeTier: true,
        });
    }, [openPaywallUpsell]);
    if (!BUILD_CAPABILITIES.payments || (!isLoggedOut && !showUpgradeButton))
        return null;
    return isLoggedOut ? (_jsx(SidebarViewPlansButton, { isExpanded: isExpanded, onViewPlansClick: handleViewPlansClick })) : (_jsx(SidebarUpgradeButton, { isExpanded: isExpanded, onUpgradeClick: handleUpgradeClick }));
}
//# sourceMappingURL=SidebarPlans.js.map